module.exports = __webpack_public_path__ + "static/media/improve_acc_eng_03.f2cdca4b.png";